import type {ReactElement} from 'react';
import React from 'react';
import {BottomBarItemColorFill} from '@Components/poster-editor/components/poster-editor-bottom-bar/components/bottom-bar-item-color-fill';
import {useGetKeyFromFillOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfActiveItem';

export function VectorItemColorFill(): ReactElement | null {
  const fillType = useGetKeyFromFillOfActiveItem('fillType');
  const fillColor = useGetKeyFromFillOfActiveItem('fillColor');

  if (!fillColor || fillType === undefined) {
    return null;
  }

  return <BottomBarItemColorFill type={fillType} color={fillColor} />;
}
